import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import manStroke from '../../assets/images/man_stroke.png';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

const StyledPlayerInfo = styled.div`
	position: absolute;
	top: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 500px;
	height: 860px;
	background-size: 500px 860px;
	background-repeat: no-repeat;
	background-position: center;
`;

const StyledPlayerInfoLeft = styled(StyledPlayerInfo)`
	left: 0;
	background-image: url(${manStroke});
`;

const StyledPlayerInfoRight = styled(StyledPlayerInfo)`
	right: 0;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: url(${manStroke});
		transform: scaleX(-1);
	}
`;

const StyledPlayerInfoMoney = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 17px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
	}
`;

const StyledExchangeContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: grid;
	grid-template-columns: 440px 440px;
	gap: 100px;
`;

const StyledSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledSectionHeading = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	& > ${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledExhangeLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

const StyledInventoryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 10px;
`;

const StyledCountContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: rgba(255, 255, 255, 0.5);

		span {
			font-size: 16px;
			color: #ffffff;
		}
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledExchangeRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledMoneyContainer = styled.div`
	display: grid;
	grid-template-columns: 260px 1fr;
	gap: 10px;
`;

export {
	StyledContainer,
	StyledCountContainer,
	StyledExchangeContainer,
	StyledExchangeRightContainer,
	StyledExhangeLeftContainer,
	StyledInventoryGrid,
	StyledMoneyContainer,
	StyledPlayerInfoLeft,
	StyledPlayerInfoMoney,
	StyledPlayerInfoRight,
	StyledSection,
	StyledSectionHeading,
};
